var map = {
	"./docker.png": "6ebb",
	"./git.png": "0a87",
	"./js.png": "d298",
	"./mongo.png": "cf1b",
	"./postgresql.png": "7e3e",
	"./python.png": "92db",
	"./vue.png": "2540"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "79d4";